import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { CapacityGranularity } from "@planzone/dto";

import { ArrowIcon } from "@common/assets/arrowIcon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import styles from "./styles.scss";

const GRANULARITY_OPTIONS: CapacityGranularity[] = ["MONTH", "WEEK"];

const GRANULARITY_LABELS: { [key in CapacityGranularity]: string } = {
  MONTH: "capacityPage.toolbar.monthlyView",
  WEEK: "capacityPage.toolbar.weeklyView",
};

function GranularitySelector(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.granularitySelector}>
      <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
        {({ isOpen, select }) => ({
          input: (
            <div
              className={classNames(styles.input, {
                [styles.opened]: isOpen,
              })}
            >
              <p>{t(GRANULARITY_LABELS[props.granularity])}</p>
              <ArrowIcon className={styles.icon} />
            </div>
          ),
          list: (
            <div className={styles.list}>
              {GRANULARITY_OPTIONS.map((option) => (
                <div
                  key={option}
                  className={classNames(styles.option, {
                    [styles.selected]: props.granularity === option,
                  })}
                  onClick={() => select(props.setGranularity(option))}
                >
                  <p>{t(GRANULARITY_LABELS[option])}</p>
                </div>
              ))}
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { GranularitySelector };
